<template>
  <div>
    <v-row>
      <v-col>
        <v-alert
          v-if="serviceAlert"
          class="ma-0 fill-height pb-6"
          :type="tokenAlert.show ? tokenAlert.type : serviceAlert.type"
          outlined
          :icon="false"
          border="bottom"
          text
        >
          <v-row>
            <v-col>
              <v-row class="fill-height" no-gutters>
                <v-col cols="12">
                  <div class="title font-weight-regular black--text mb-3" v-html="serviceAlert.title"></div>
                  <div class="grey--text text--darken-3" v-html="serviceAlert.text"></div>
                </v-col>
                <v-col align-self="end">
                  <v-btn
                    v-if="serviceAlert.buttonShow"
                    class="mt-6 mr-3"
                    depressed
                    color="primary"
                    @click="serviceAlert.buttonClick"
                  >
                    {{ serviceAlert.buttonText }}
                  </v-btn>

                  <v-btn
                    v-if="
                      (filteredPeriods.current.length > 0 || filteredPeriods.incoming.length > 0) &&
                        agreement.servicePlan.type === 'fixed_term' &&
                        !agreement.automaticRenewal &&
                        agreement.expectedStatus !== 'suspended_for_non_payment'
                    "
                    depressed
                    class="mt-6"
                    color="primary"
                    @click="openAutomaticRenewalDialog"
                    >{{ $t('message.activate_automatic_renewal_btn') }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>

            <template v-if="tokenAlert.show">
              <v-divider
                v-if="$vuetify.breakpoint.smAndUp"
                vertical
                :class="tokenAlert.show ? tokenAlert.type : serviceAlert.type"
                class="mx-3"
              ></v-divider>
              <v-col>
                <v-row no-gutters class="fill-height">
                  <v-col cols="12">
                    <div class="title font-weight-regular black--text mb-3" v-html="tokenAlert.title"></div>
                    <div class="mb-6 grey--text text--darken-3" v-html="tokenAlert.text"></div>
                  </v-col>
                  <v-col align-self="end">
                    <v-btn depressed color="primary" @click="tokenAlert.buttonClick">
                      {{ tokenAlert.buttonText }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </template>
          </v-row>
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'Alert',

  props: {
    agreement: {
      type: Object,
      required: true
    },
    currentPeriod: {
      type: Object,
      required: false,
      default: null
    },
    nextPeriod: {
      type: Object,
      required: false,
      default: null
    },
    filteredPeriods: {
      type: Object,
      required: false,
      default: null
    },
    hasAllowedTokens: {
      type: Boolean,
      required: false,
      default: false
    },
    showDate: {
      type: Number,
      required: true
    },
    minStartDate: {
      type: Date,
      required: true
    }
  },
  computed: {
    nextDoneActivation() {
      if (!this.filteredPeriods) {
        return
      }
      let activation = null

      if (this.filteredPeriods.incoming.length > 0) {
        this.filteredPeriods.incoming.forEach(incoming => {
          if (true === incoming.paid && null === activation) {
            activation = incoming
          }
        })
      }

      return activation
    },

    hasActiveVolumeToken() {
      if (!this.agreement || !this.agreement.contractuallyActivated || !this.currentPeriod) {
        return false
      }

      let activeVolumeToken = false

      this.currentPeriod.volumeTokens.forEach(volumeToken => {
        if ('active' === volumeToken.status) {
          activeVolumeToken = true
        }
      })

      return activeVolumeToken
    },

    serviceAlert() {
      let serviceAlert = {
        type: 'error',
        title: '',
        text: '',
        buttonShow: true,
        buttonText: '',
        buttonClick: () => {}
      }

      serviceAlert.type = this.agreement.contractuallyActivated ? 'success' : 'error'

      const activating =
        this.currentPeriod &&
        this.currentPeriod.airtimePlan &&
        this.currentPeriod.airtimePlan.monthlyVolume &&
        !this.agreement.contractuallyActivated

      const depleted =
        this.hasAllowedTokens &&
        this.currentPeriod &&
        !this.volumeTokensStatusCount.active_base_tokens &&
        !this.volumeTokensStatusCount.active_additional_tokens &&
        !this.volumeTokensStatusCount.almost_depleted_base_tokens &&
        !this.volumeTokensStatusCount.almost_depleted_additional_tokens

      const serviceStatus = this.agreement.expectedStatus

      const renewal = this.agreement.automaticRenewal && this.currentPeriod

      //Unpayment
      if (serviceStatus === 'suspended_for_non_payment') {
        serviceAlert.title = this.$t('message.service_suspended_for_non_payment')
        serviceAlert.text = this.$t('message.service_suspended_for_non_payment_info')
        serviceAlert.buttonShow = false
        serviceAlert.type = 'error'
      }
      // Activating
      else if (activating) {
        serviceAlert.title = this.$t('message.we_are_activating_your_service')
        serviceAlert.text = this.$t('message.we_are_activating_your_service_info')
        serviceAlert.buttonShow = false
        serviceAlert.type = 'warning'
      }
      // Volume exceeded
      else if (depleted) {
        serviceAlert.title = this.$t('message.your_service_has_been_suspended')
        serviceAlert.text = this.$t('message.your_service_has_been_suspended_info')
        serviceAlert.text =
          this.$t('message.on_demand_service_active_until') +
          ' ' +
          this.$moment(this.currentPeriod.endsAt).format('LL') +
          '.'
        serviceAlert.buttonText = this.$t('message.expand_activation')
        serviceAlert.buttonClick = () => {
          this.$emit('showPeriodCreateDialog', true)
        }
      }
      // Automatic renewal
      else if (renewal) {
        serviceAlert.title = this.$t('message.recurring_service_active')
        serviceAlert.text =
          this.$t('message.next_automatic_renewal') +
          ' ' +
          this.$moment(this.currentPeriod.endsAt).format('LL') +
          '.' +
          ' ' +
          this.$t('message.automatic_renewal_info', {
            term: this.$t('message.renewal_' + this.agreement.automaticRenewal).toLowerCase()
          })
        serviceAlert.buttonText = this.$t('message.cancel')
        serviceAlert.buttonClick = () => {
          this.stopAutomaticRenewal()
        }
      } else {
        // Recurring without maxDeactivation
        if (
          'recurring' === this.agreement.servicePlan.type &&
          !this.agreement.maxDeactivation &&
          !this.agreement.servicePlan.maxDeactivation
        ) {
          serviceAlert.title = this.$t('message.recurring_service_active')
          serviceAlert.text = null
          serviceAlert.buttonShow = false
        }
        // Recurring
        else if ('recurring' === this.agreement.servicePlan.type) {
          if (this.currentPeriod && this.currentPeriod.type === 'stop') {
            serviceAlert.title = this.$t('message.recurring_service_stopped')
            if (this.currentPeriod.endsAt) {
              serviceAlert.text =
                this.$t('message.recurring_service_stopped_until') +
                ' ' +
                this.$moment(this.currentPeriod.endsAt).fromNow() +
                '. '
            } else {
              serviceAlert.text = this.$t('message.recurring_service_need_connection')
            }

            if (this.agreement.remainingDeactivationDays[this.showDate] > 0) {
              serviceAlert.text += this.$t('message.you_have_days_of_stop_to_use', {
                days: this.agreement.remainingDeactivationDays[this.showDate],
                year: this.showDate
              })
            } else {
              serviceAlert.text += this.$t('message.you_do_not_have_any_stop_day_remaining', {
                year: this.showDate
              })
            }

            if (!this.currentPeriod.endsAt || new Date(this.currentPeriod.endsAt) > this.minStartDate) {
              serviceAlert.buttonText = this.$t('message.reactivation_request')
              serviceAlert.buttonClick = () => {
                this.$emit('showStopReactivateDialog', true)
              }
            } else {
              serviceAlert.buttonText = this.$t('message.request_stop')
              serviceAlert.buttonClick = () => {
                this.$emit('showPeriodCreateDialog', true)
              }
            }
          } else {
            serviceAlert.title = this.$t('message.recurring_service_active')
            if (this.nextPeriod) {
              serviceAlert.text =
                this.$t('message.recurring_service_next_stop') +
                ' ' +
                this.$moment(this.nextPeriod.startsAt).fromNow() +
                '. '
            } else {
              serviceAlert.text = this.$t('message.recurring_service_need_request_stop')
            }
            if (this.agreement.remainingDeactivationDays[this.showDate] > 0) {
              serviceAlert.text += this.$t('message.you_have_days_of_stop_to_use', {
                days: this.agreement.remainingDeactivationDays[this.showDate],
                year: this.showDate
              })
            } else {
              serviceAlert.text += this.$t('message.you_do_not_have_any_stop_day_remaining', {
                year: this.showDate
              })
            }
            serviceAlert.buttonText = this.$t('message.request_stop')
            serviceAlert.buttonClick = () => {
              this.$emit('showPeriodCreateDialog', true)
            }
          }
        }
        // On Demand
        else {
          if (!this.agreement.contractuallyActivated) {
            serviceAlert.title = this.$t('message.on_demand_service_down')
            if (this.nextDoneActivation) {
              serviceAlert.text =
                this.$t('message.on_demand_service_down_until') +
                ' ' +
                this.$moment(this.nextDoneActivation.startsAt).fromNow() +
                '.'
            } else {
              serviceAlert.text = this.$t('message.on_demand_service_need_connection')
            }
            serviceAlert.buttonText = this.$t('message.request_activation')
            serviceAlert.buttonClick = () => {
              this.$emit('showPeriodCreateDialog', true)
            }
          } else {
            serviceAlert.title = this.$t('message.on_demand_service_active')
            if (this.currentPeriod) {
              serviceAlert.text =
                this.$t('message.on_demand_service_active_until') +
                ' ' +
                this.$moment(this.currentPeriod.endsAt).format('LL') +
                '.'
            }

            serviceAlert.buttonText = this.$t('message.expand_activation')
            serviceAlert.buttonClick = () => {
              this.$emit('showPeriodCreateDialog', true)
            }
          }
        }
      }

      return serviceAlert
    },

    tokenAlert() {
      let tokenAlert = {
        type: 'error',
        show: false,
        title: '',
        text: '',
        buttonText: '',
        buttonClick: () => {}
      }

      if (this.currentPeriod && this.currentPeriod.airtimePlan && this.currentPeriod.airtimePlan.monthlyVolume) {
        tokenAlert.show = true
        tokenAlert.title = this.$t('message.volume_token_info_title', {
          volume: this.currentPeriod.airtimePlan.monthlyVolume
        })

        const count = this.volumeTokensStatusCount

        if (count.active_base_tokens > 0) {
          tokenAlert.type = 'success'
          tokenAlert.text = this.$t('message.volume_token_info_paragraph.low_consumption')
        }

        if (count.almost_depleted_base_tokens > 0 && count.available_tokens === 0) {
          tokenAlert.type = 'warning'
          tokenAlert.text = this.$t('message.volume_token_info_paragraph.almost_depleted')
        }

        if (count.almost_depleted_base_tokens > 0 && count.available_tokens > 0) {
          tokenAlert.type = 'success'
          tokenAlert.text = this.$t('message.volume_token_info_paragraph.additional_soon')
        }

        if (count.depleted_base_tokens > 0 && count.available_tokens === 0) {
          tokenAlert.type = 'error'
          tokenAlert.text = this.$t('message.volume_token_info_paragraph.depleted')
        }

        if (count.depleted_base_tokens > 0 && count.active_additional_tokens > 0) {
          tokenAlert.type = 'success'
          tokenAlert.text =
            this.$t('message.volume_token_info_paragraph.consuming_additional') +
            ' ' +
            this.$t('message.volume_token_info_paragraph.low_consumption')
        }

        if (count.depleted_base_tokens > 0 && count.almost_depleted_additional_tokens > 0) {
          tokenAlert.type = 'warning'
          tokenAlert.text =
            this.$t('message.volume_token_info_paragraph.consuming_additional') +
            ' ' +
            this.$t('message.volume_token_info_paragraph.almost_depleted')
        }

        if (
          count.depleted_base_tokens > 0 &&
          count.almost_depleted_additional_tokens > 0 &&
          count.available_tokens > 0
        ) {
          tokenAlert.type = 'success'
          tokenAlert.text =
            this.$t('message.volume_token_info_paragraph.consuming_additional') +
            ' ' +
            this.$t('message.volume_token_info_paragraph.next_additional_soon')
        }

        if (count.base_tokens === 0) {
          tokenAlert.type = 'warning'
        }

        tokenAlert.buttonText = this.$t('message.add_token')
        tokenAlert.buttonClick = () => {
          this.$emit('showVolumeTokenCreateDialog', true)
        }
      }

      return tokenAlert
    },

    volumeTokensStatusCount() {
      if (!this.currentPeriod) {
        return
      }
      let count = {
        active_base_tokens: 0,
        active_additional_tokens: 0,
        almost_depleted_base_tokens: 0,
        almost_depleted_additional_tokens: 0,
        available_tokens: 0,
        depleted_base_tokens: 0,
        base_tokens: 0
      }

      this.currentPeriod.volumeTokens.forEach(volumeToken => {
        if (volumeToken.base) {
          count.base_tokens++
        }

        if ('active' === volumeToken.status) {
          if (volumeToken.base) {
            count.active_base_tokens++
          } else {
            count.active_additional_tokens++
          }
        } else if ('almost_depleted' === volumeToken.status) {
          if (volumeToken.base) {
            count.almost_depleted_base_tokens++
          } else {
            count.almost_depleted_additional_tokens++
          }
        } else if ('available' === volumeToken.status) {
          count.available_tokens++
        } else if ('depleted' === volumeToken.status) {
          if (volumeToken.base) {
            count.depleted_base_tokens++
          }
        }
      })
      return count
    }
  },

  methods: {
    openAutomaticRenewalDialog() {
      this.$emit('openAutomaticRenewalDialog', true)
    },
    stopAutomaticRenewal() {
      this.$emit('stopAutomaticRenewal', true)
    }
  }
}
</script>
